import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const NotificacionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")

  const [datosTabla] = useState({
    titulo: "Notificaciones",
    ruta: "/notificacion",
    esAgregar: true,
    esEditar: false,
    esEliminar: false,
    //eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "TÍTULO", key: "titulo" },
    { title: "SUBTÍTULO", key: "subtitulo" },
    { title: "TIPO", key: "tipo" },
    { title: "DESTINATARIOS", key: "destinatarios" },
    { title: "ESTADO", key: "estado" },
    { title: "FECHA ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/push-notifications",{
        method: "GET",
      });
      console.log(data);
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar las notificaciones.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar las notificaciones.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : (
          <>
            { error && (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            )}
            <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/>
          </>
        )}
      </MasterLayout>
    </>
  );
};

export default NotificacionesPage;
